// extracted by mini-css-extract-plugin
export default {"radio__field":"src-UI-RadioButton--radio__field","radio":"src-UI-RadioButton--radio","radio__label":"src-UI-RadioButton--radio__label"};